import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import transformerData from '../../utils/transformer';

const { CMS_DATA, CMS_ENV, CONTENTFUL_HOME_ID, CMS_COUNTRY, CMS_LOCALE_LANGUAGE, X_CLIENT_HEADER } =
    process.env.REACT_APP_MARKET_VALUES;
export const topicApi = createApi({
    reducerPath: 'topics',
    baseQuery: fetchBaseQuery({
        baseUrl: CMS_DATA,
        prepareHeaders: (headers) => {
            headers.set('x-client-id', X_CLIENT_HEADER);
            return headers;
        },
    }),
    tagTypes: ['Topic'],
    endpoints: (build) => ({
        getTopic: build.query({
            query: () =>
                CMS_LOCALE_LANGUAGE === null || CMS_LOCALE_LANGUAGE === 'null'
                    ? `?market=${CMS_COUNTRY}&environment=${CMS_ENV}&entryId=${CONTENTFUL_HOME_ID}`
                    : `?market=${CMS_COUNTRY}&environment=${CMS_ENV}&locale=${CMS_LOCALE_LANGUAGE}&entryId=${CONTENTFUL_HOME_ID}`,
            providesTags: ['Topic'],
            transformResponse(response) {
                const dataSource = response.items[0];
                return transformerData(dataSource);
            },
        }),
    }),
});
export const { useGetTopicQuery } = topicApi;
